{
  "name": "@kakuilan/react-vditor",
  "version": "0.2.4",
  "description": "Vditor in React",
  "main": "lib/index.js",
  "typings": "lib/index.d.ts",
  "module": "lib/index.mjs",
  "files": [
    "lib",
    "package.json",
    "README.md"
  ],
  "publishConfig": {
    "access": "public",
    "registry": "https://registry.npmjs.org"
  },
  "scripts": {
    "dev": "tsup --watch",
    "build": "tsup",
    "test": "echo \"Error: no test specified\" && exit 1"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/kakuilan/react-vditor"
  },
  "keywords": [
    "Vditor",
    "React",
    "markdown editor"
  ],
  "author": "kakuilan",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/kakuilan/react-vditor/issues"
  },
  "homepage": "https://github.com/kakuilan/react-vditor#readme",
  "devDependencies": {
    "@types/react": "^18.2.20",
    "@types/react-dom": "^18.2.7",
    "react": "^18.2.0",
    "react-dom": "^18.2.0",
    "tsup": "^7.2.0",
    "typescript": "^5.1.6",
    "vditor": "^3.9.4"
  }
}